import { useEffect, useRef, useState } from 'react'

const useDetectScroll = () => {
  const scrollDetector = useRef<HTMLDivElement>(null)
  const [isPageScrolled, setIsPageScrolled] = useState(false)

  useEffect(() => {
    if (!scrollDetector.current) {
      return
    }
    const element = scrollDetector.current!
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        return setIsPageScrolled(false)
      }
      return setIsPageScrolled(true)
    })
    observer.observe(element)
    return () => {
      if (element) {
        observer.unobserve(element)
      }
    }
  }, [])

  return { scrollDetector, isPageScrolled }
}

export default useDetectScroll
